import { Pagination } from 'swiper/modules';
import Swiper from 'swiper';

export default function initGallery() {
  Alpine.data('gallery', () => ({
    swiper: null as Swiper | null,
    init() {
      const swiperEl = this.$el.querySelector('.gallery-swiper') as HTMLElement;
      if (swiperEl) {
        this.swiper = new Swiper(swiperEl, {
          modules: [Pagination],
          slidesPerView: 1,
          loop: true,
          spaceBetween: 30,
          pagination: {
            el: `#${this.$el.id} .gallery-swiper-pagination`,
            type: 'bullets',
            bulletClass: 'size-2 bg-dark/10 rounded-full cursor-pointer hover:bg-green-200 transition-all',
            bulletActiveClass: 'w-8 bg-green-200!',
            bulletElement: 'button',
            clickable: true,
          },
        });
      } else {
        this.updateStickyOffsets();
        window.addEventListener('resize', () => this.updateStickyOffsets());
      }
    },
    updateStickyOffsets() {
      const stickyStep = window.innerWidth < 992 ? 50 : 70;

      this.$el.querySelectorAll<HTMLElement>('.top-sticky').forEach((el) => {
        const { index } = el.dataset;
        if (index) {
          /* eslint-disable no-param-reassign */
          el.style.top = `${120 + (Number(index) * stickyStep)}px`;
        }
      });
    }
  }));
}
